const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";
    let majorVersion = "0";
    let fullVersion = "0";
  
    if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Mozilla Firefox";
      const match = userAgent.match(/Firefox\/([0-9]+)\.([0-9]+)/);
      majorVersion = match ? match[1] : '0';
      fullVersion = match ? match[0] : '0';
    } else if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Google Chrome";
      const match = userAgent.match(/Chrome\/([0-9]+)\.([0-9]+)/);
      majorVersion = match ? match[1] : '0';
      fullVersion = match ? match[0] : '0';
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Apple Safari";
      const match = userAgent.match(/Version\/([0-9]+)\.([0-9]+)/);
      majorVersion = match ? match[1] : '0';
      fullVersion = match ? match[0] : '0';
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
      browserName = "Microsoft Internet Explorer";
      const match = userAgent.match(/(?:MSIE |rv:)([0-9]+)\.([0-9]+)/);
      majorVersion = match ? match[1] : '0';
      fullVersion = match ? match[0] : '0';
    }
  
    return { browserName, majorVersion, fullVersion };
  };
  
  const getDeviceInfo = () => {
    const { browserName, majorVersion, fullVersion } = getBrowserInfo();
  
    const deviceInfo = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      isMobile: /Mobi|Android/i.test(navigator.userAgent),
      isTablet: /Tablet|iPad/i.test(navigator.userAgent),
      language: navigator.language || navigator.userLanguage,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      hardwareConcurrency: navigator.hardwareConcurrency || 'N/A',
      deviceMemory: navigator.deviceMemory || 'N/A',
      touchSupport: 'ontouchstart' in window ? 'Supported' : 'Not supported',
      browserName,
      majorVersion,
      fullVersion,
    };
  
    return deviceInfo;
  };
  
  export default getDeviceInfo;